import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";

const apiClient = createApiClient("json");
const BASE_URL = "/api/main/trackers";

const fetchListData = async () => {
  const { data = [] } = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  return {
    data,
    total: data.length,
  };
};

export const trackersSchema: DataProviderSchema<"Tracker", "json"> = {
  list: fetchListData,
};
